import React, { useState } from 'react';

import { DropdownItem } from '@mesh.ai/rabbit';
import { useGoalsWeight } from 'components/GoalsWeight/GoalsWeightContext';
import { useAuthenticatedUser } from 'components/hooks/dataHooks';
import useOKRCreationPermissionsBasedOnEmployeeGoalsPrivileges from 'components/hooks/useOKRCreationPermissionsBasedOnEmployeeGoalsPrivileges';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import CreateExperiencePanel from 'screens/Engagement/CreateExperiencePanel';
import CreateCheckInSidepanel from 'screens/admin/CheckIn/CreateCheckInSidepanel';
import { useGenerateFeedbackDrawerParams } from 'screens/performanceReview/components/ContinuousFeedback/Drawers/hooks/useGenerateFeedbackDrawerParams';

import { FEEDBACK_FORM_TYPE } from 'constants/ProjectConstants';
import { modifyString, StringModifier } from 'constants/copyHelpers';
import { sendClickedOnCreateKRevent, sendClickedOnQuickActionsEvent } from 'constants/mixpanelHelper';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { ACTIONS_LIST } from './ActionsList';

const QuickActions = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const { user } = useAuthenticatedUser();

  const { showSidePanel, hideSidePanel } = useGoalsWeight();

  const { moduleName, keyResultsName } = useOrganisationSettings();

  const sharePublicPraiseParams = useGenerateFeedbackDrawerParams({
    empId: null,
    formType: FEEDBACK_FORM_TYPE.PROVIDED,
    newForm: true,
    isSharePublicPraise: true,
    source: 'Quick Actions',
  });

  const shareFeedbackParams = useGenerateFeedbackDrawerParams({
    empId: null,
    formType: FEEDBACK_FORM_TYPE.PROVIDED,
    newForm: true,
    source: 'Quick Actions',
    isSharePublicPraise: false,
  });

  const requestFeedbackParams = useGenerateFeedbackDrawerParams({
    empId: user?.id,
    formType: FEEDBACK_FORM_TYPE.REQUESTED,
    newForm: true,
    source: 'Quick Actions',
    isSharePublicPraise: false,
  });

  const [isOneOnOnePanelOpen, setIsOneOnOnePanelOpen] = useState(false);
  const [isExperiencePanelOpen, setIsExperiencePanelOpen] = useState(false);

  const { canCreateKeyResultUnderKeyResult, canCreateKeyResultUnderObjective, canCreateKeyResultAtRootLevel } =
    useOKRCreationPermissionsBasedOnEmployeeGoalsPrivileges();

  const canCreateKeyResult =
    canCreateKeyResultAtRootLevel || canCreateKeyResultUnderObjective || canCreateKeyResultUnderKeyResult;
  const FILTERED_QUICK_ACTIONS_LIST = ACTIONS_LIST.filter(({ id }) => {
    if (id === 'create-goal') {
      return canCreateKeyResult;
    }
    return true;
  });

  const openMyWeightageSidePanel = () => {
    showSidePanel({
      employeeId: user?.id,
      canEdit: true,
      onCancel: () => {
        hideSidePanel();
      },
      onSuccess: () => {
        hideSidePanel();
      },
    });
  };

  return (
    <>
      {FILTERED_QUICK_ACTIONS_LIST.map(({ displayName, id, Icon, isActionVisible, onClick }) => {
        let modifiedDisplayName = displayName;
        if (id === 'create-goal') {
          modifiedDisplayName = `Add a ${modifyString(keyResultsName, StringModifier.SENTENCE_CASE)}`;
        }

        if (id === 'manage-goal-weightage') {
          modifiedDisplayName = `Add ${modifyString(moduleName, StringModifier.SENTENCE_CASE)} weightages`;
        }

        if (isActionVisible()) {
          return (
            <DropdownItem
              key={displayName}
              style={{
                alignItems: 'center',
              }}
              onSelect={() => {
                if (displayName === `Add a goal`) {
                  sendClickedOnCreateKRevent({
                    eventProperties: { source: 'Quick Actions', page: 'Home' },
                  });
                }
                sendClickedOnQuickActionsEvent({
                  eventProperties: {
                    action: displayName,
                  },
                });
                onClick({
                  employee: user,
                  dispatch,
                  setIsOneOnOnePanelOpen,
                  setIsExperiencePanelOpen,
                  history,
                  employeeId: user?.id,
                  openMyWeightageSidePanel,
                  location,
                  sharePublicPraiseParams,
                  shareFeedbackParams,
                  requestFeedbackParams,
                });
              }}
            >
              <Icon boxSize="24px" color="text.g2" fill="transparent" />
              <TextBodyMedium ml="12px" color="text.g1">
                {modifiedDisplayName}
              </TextBodyMedium>
            </DropdownItem>
          );
        }
      })}
      <CreateCheckInSidepanel
        isOpen={isOneOnOnePanelOpen}
        setIsOpen={setIsOneOnOnePanelOpen}
        currentOneOnOneEmployees={[]}
        loggedInEmployeeId={user.id}
        forceUpdateParent={() => {}}
      />
      <CreateExperiencePanel open={isExperiencePanelOpen} onCancel={() => setIsExperiencePanelOpen(false)} />
    </>
  );
};

export { QuickActions };
